<script>
import baseEdit from "@/views/components/base/baseEdit.vue";

export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "demand",
      key: "id",
      kv: "",
      url: {},
      items: [
        { label: "新建需求", type: "header" },
        {
          label: "需求科室",
          name: "deskId",
          value: "",
          type: "selectDesk",
          width: "400px",
          dropList: [],
          rules: [
            {
              required: true,
              message: "科室不能为空",
              trigger: "blur",
              type: "number",
            },
          ],
          selected: 0,
        },
        {
          label: "发起人",
          name: "proposerId",
          type: "select",
          width: "400px",
          value: "",
          dropList: [],
          rules: [{ required: true, trigger: "blur", type: "number" }],
        },
        {
          label: "需求内容",
          name: "content",
          value: "",
          type: "textarea",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "需求原因",
          name: "reason",
          value: "",
          type: "textarea",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "紧急程度",
          name: "urgency",
          type: "select",
          width: "400px",
          value: "1",
          dropList: [
            {
              value: 1,
              name: "一般",
            },
            {
              value: 2,
              name: "较重",
            },
            {
              value: 3,
              name: "重要",
            },
            {
              value: 4,
              name: "特别重要",
            },
          ],
          rules: [
            {
              required: true,
              message: "请选择紧急程度",
              trigger: "blur",
              type: "number",
            },
          ],
        },
        // { label: "发起时间", name: "applyTime", value: "", type: "datetime" },
        {
          label: "相关文件",
          name: "demandFileUrl",
          value: "",
          type: "documents",
          desc: "",
        },
        {
          label: "接单人",
          name: "accepterName",
          value: "",
          type: "input",
          disabled: true,
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },

        {
          label: "指派负责人",
          name: "initialAssigneeId",
          type: "select",
          width: "400px",
          value: "",
          dropList: [],
          rules: [{ required: true, trigger: "blur", type: "number" }],
        },
      ],
      forms: {},
    };
  },
  async created() {
    await this.loadAdminUserData();
    this.loadLevelData();
    this.forms.accepterId = $utils.data.get("auth", "uid");
    this.forms.accepterName = $utils.data.get("auth", "userName");
    this.forms.initialAssigneeId = $utils.data.get("auth", "uid");
    this.forms.proposerId = $utils.data.get("auth", "uid");
    // await this.projectData();
    // let query = this.$route.query;
    // if (query && query.action === "edit") {
    //   this.kv = query.kv;
    //   this.initData();
    // }
  },
  mounted() {
    // this.onisParent(1);
  },
  methods: {
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load(`/admin/system/desk/selectList`, q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.deskName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "deskId") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    initData() {
      // 加载详情数据
      let id = this.kv;
      $utils.api.load(`/admin/system/task/${id}`, {}).then((res) => {
        if (res && res.data) {
          this.forms = res.data;
          if (res.data.state == 1) {
            this.onisParent(1);
          } else {
            this.onisParent(2);
          }
          console.log(res.data);
        }
      });
    },
    //1代表存在父级
    //0代表不存在父级
    onisParent(val) {
      if (val == 1) {
        this.items[this.getItemIndex("resultFileUrl")].type = "kong";
        this.items[this.getItemIndex("finishContent")].type = "kong";
      }
      if (val == 2) {
        this.items[this.getItemIndex("resultFileUrl")].type = "documents";
        this.items[this.getItemIndex("finishContent")].type = "textarea";
      }
    },
    async handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      console.log(q);
      await this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/admin/system/sysDemand/add`, q, "POST")
            .then((res) => {
              this.sloading = false;
              if (res.code == 200) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
              // if (this.action == "edit") {
              //   setTimeout(() => {
              //     this.$Modal.remove();
              //     $utils.url.go(-1);
              //   }, 1000);
              // } else {
              //   setTimeout(() => {
              //     this.$Modal.remove();
              //     $utils.url.go(-1);
              //   }, 1000);
              // }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },

    //选择处理人下拉框
    async loadAdminUserData() {
      // 通过pk查询字典数据
      let q = {};
      let res = await $utils.api.load("/admin/system/user/listPrincipal", q);
      if (res && res.rows) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.nickName;
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "initialAssigneeId") {
            this.items[index]["dropList"] = dropList;
          }
          if (element && element.name == "proposerId") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
  },
};
</script>
